<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div
      class="row justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
      :style="isMobile ? '' : 'max-height: 68vh'"
    >
      <div class="col-12 col-lg-11">
        <div
          class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
          v-for="item in transactionData"
          :key="item.id"
        >
          <div class="card-body p-lg-4">
            <div class="row g-4 position-relative">
              <div class="col">
                <div class="fw-medium d-block">
                  <span class="d-block">
                    <b
                      >{{ item.id > 0 ? item.transactionType : 'شارژ کیف پول' }}
                    </b>
                    <span class="smaller text-secondary">{{
                      item.paymentType ? ' (' + item.paymentType + ')' : ''
                    }}</span>
                  </span>
                  <span dir="ltr" class="d-block smaller"
                    >{{ getPersianDateTime(item.dateTime) }}
                    <span v-if="isOverseas()">
                      |
                      <small class="gregorianDateClass"
                        >{{ getGregorianDateTime(item.dateTime) }}
                      </small></span
                    >
                  </span>
                  <span class="d-block smaller text-muted" v-if="item.id > 0">
                    {{ item.transactionType }}
                    {{ item.transactionTypeID == 1 ? 'به' : 'از' }} کیف پول بابت
                    {{ item.operationType }}
                  </span>
                  <span
                    class="d-block smaller"
                    :class="
                      item.rechargeWalletStatusID == 2
                        ? 'text-success'
                        : item.rechargeWalletStatusID == 3
                        ? 'text-danger'
                        : ''
                    "
                    v-if="item.id <= 0"
                  >
                    {{ item.rechargeWalletStatus }}
                    {{
                      item.rechargeWalletStatusID == 1
                        ? '(در انتظار بررسی)'
                        : ''
                    }}
                  </span>
                  <div class="mt-2">
                    <a
                      class="small text-secondary"
                      :href="`#collapseDetail_${item.id}`"
                      data-bs-toggle="collapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                      v-if="item.sessionDetailTransaction"
                    >
                      جزئیات
                      <!-- <i class="fi fi-arrow-down-slim"></i> -->
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-chevron-compact-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-5 col-lg-4 text-start">
                <span
                  :class="{
                    'text-success': item.transactionTypeID == 1,
                    'text-danger': item.transactionTypeID == 2,
                  }"
                >
                  {{ getThousandAmount(item.amount) }}</span
                >
                <span
                  class="smaller"
                  :class="{
                    'text-success': item.transactionTypeID == 1,
                    'text-danger': item.transactionTypeID == 2,
                  }"
                  >{{ item.transactionTypeID == 1 ? '+' : '-' }}</span
                >
                <span class="me-2 smaller text-secondary">{{
                  item.currencyType
                }}</span>
              </div>
            </div>
            <div class="collapse" :id="`collapseDetail_${item.id}`">
              <div class="card card-body small justified">
                <span class="d-block text-success smaller mb-1"
                  ><b>توضیحات:</b></span
                >
                <p class="small justified p-0 m-0">
                  {{ item.sessionDetailTransaction }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
          v-if="transactionData.length == 0"
        >
          <div class="card-body d-flex justify-content-between">
            <div class="w-100 pt-1 text-center">
              <strong class="d-block fs-6 fw-medium">
                گردش حسابی وجود ندارد</strong
              >
            </div>
          </div>
        </div>
        <div class="text-center my-2">
          <button
            class="btn btn-soft btn-light btn-sm text-black"
            @click="moreTransactionClick"
            v-if="hasMoreRecord"
          >
            <i class="fi fi-plus"></i>
            <span>نمایش بیشتر</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import axios from 'axios';

export default {
  components: {
    LoadingSpinner,
  },
  inject: ['WalletList', 'SetSelectedTab'],
  data() {
    return {
      isMobile: isMobile,
      transactionData: [],
      hasMoreRecord: false,
      searchData: {
        walletID: 0,
        recordCount: 9,
      },
    };
  },
  props: {
    selectedWalletID: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    getThousandAmount(amount) {
      /* eslint-disable */
      return thousandSeprator(amount);
    },
    getPersianDateTime(date) {
      /* eslint-disable */
      return (
        new persianDate(new Date(date)).format('L') +
        ' ' +
        `${new persianDate(new Date(date)).format('LT')}`
      );
    },

    getGregorianDateTime(date) {
      // eslint-disable-next-line
      return getGregorianDateTime(date);
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
    async getTransactions() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/FN/Transaction/GetTransactoinForSiteWallet', that.searchData)
        .then((response) => {
          that.transactionData = response.data.transactionData;
          that.hasMoreRecord =
            response.data.allRecourdCount >
            response.data.transactionData.length;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت داده های تراکنش ها با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async moreTransactionClick() {
      this.searchData.recordCount += 9;
      await this.getTransactions();
    },

    getCurrentWallet() {
      let wallet = this.WalletList().filter(
        (f) => f.id == this.selectedWalletID
      );
      if (wallet.length > 0) {
        return wallet[0];
      }
      return null;
    },
  },
  async mounted() {
    this.searchData.walletID = this.selectedWalletID;
    await this.getTransactions();
  },
};
</script>
